import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createVNode as _createVNode, normalizeStyle as _normalizeStyle, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '@/assets/images/illustrations/not_found.png'


const _hoisted_1 = { class: "__report-lesson px-12 md-down:px-4 pb-30" }
const _hoisted_2 = { class: "__report-lesson__header pt-10 flex flex-nowrap justify-between md-down:flex-col md-down:gap-6" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "__record__title text-neutral-500 font-semibold whitespace-nowrap flex flex-nowrap items-center text-4xl" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    class: "mr-3 h-6 w-6",
    fill: "none",
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      "clip-rule": "evenodd",
      d: "M0.0867744 6.22202C0.440527 4.66346 1.83439 3.5 3.5 3.5H24.5C26.1656 3.5 27.5595 4.66346 27.9132 6.22202L14 14.7245L0.0867744 6.22202ZM0 8.2199V20.651L10.1556 14.4261L0 8.2199ZM11.8325 15.4508L0.335774 22.4978C0.897057 23.6815 2.10294 24.5 3.5 24.5H24.5C25.8971 24.5 27.1029 23.6815 27.6642 22.4978L16.1675 15.4508L14 16.7755L11.8325 15.4508ZM17.8444 14.4261L28 20.651V8.2199L17.8444 14.4261Z",
      fill: "#65758B",
      "fill-rule": "evenodd"
    })
  ]),
  /*#__PURE__*/_createTextVNode(" Thông báo học phí ")
], -1)
const _hoisted_4 = { class: "flex items-center justify-center" }
const _hoisted_5 = /*#__PURE__*/_createStaticVNode("<svg fill=\"none\" height=\"16\" viewBox=\"0 0 16 16\" width=\"16\" xmlns=\"http://www.w3.org/2000/svg\"><path clip-rule=\"evenodd\" d=\"M1 3.66797C1 3.11568 1.44772 2.66797 2 2.66797H14C14.5523 2.66797 15 3.11568 15 3.66797C15 4.22025 14.5523 4.66797 14 4.66797H2C1.44772 4.66797 1 4.22025 1 3.66797Z\" fill=\"#94A3B8\" fill-rule=\"evenodd\"></path><path clip-rule=\"evenodd\" d=\"M2.33203 8C2.33203 7.44772 2.77975 7 3.33203 7H12.6654C13.2176 7 13.6654 7.44772 13.6654 8C13.6654 8.55228 13.2176 9 12.6654 9H3.33203C2.77975 9 2.33203 8.55228 2.33203 8Z\" fill=\"#94A3B8\" fill-rule=\"evenodd\"></path><path clip-rule=\"evenodd\" d=\"M4.33203 12C4.33203 11.4477 4.77975 11 5.33203 11H10.6654C11.2176 11 11.6654 11.4477 11.6654 12C11.6654 12.5523 11.2176 13 10.6654 13H5.33203C4.77975 13 4.33203 12.5523 4.33203 12Z\" fill=\"#94A3B8\" fill-rule=\"evenodd\"></path></svg><div class=\"ml-1.5 font-semibold text-neutral-600 whitespace-nowrap\"> Bộ lọc </div>", 2)
const _hoisted_7 = [
  _hoisted_5
]
const _hoisted_8 = {
  key: 0,
  class: "mt-8"
}
const _hoisted_9 = {
  key: 0,
  class: "__report-lesson__container"
}
const _hoisted_10 = { class: "flex items-center justify-between" }
const _hoisted_11 = { class: "mb-3 text-neutral-600 font-bold text-lg" }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = /*#__PURE__*/_createElementVNode("svg", {
  class: "-mt-1",
  fill: "none",
  height: "16",
  viewBox: "0 0 16 16",
  width: "16",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "clip-rule": "evenodd",
    d: "M16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8ZM12.0303 4.96967C11.7374 4.67678 11.2625 4.67678 10.9697 4.96967C10.9626 4.97674 10.9559 4.98424 10.9498 4.9921L7.47739 9.41674L5.38387 7.32322C5.09097 7.03033 4.6161 7.03033 4.32321 7.32322C4.03031 7.61612 4.03031 8.09099 4.32321 8.38388L6.96965 11.0303C7.26255 11.3232 7.73742 11.3232 8.03031 11.0303C8.03684 11.0238 8.04299 11.0169 8.04875 11.0097L12.041 6.01947C12.3232 5.72582 12.3196 5.25897 12.0303 4.96967Z",
    fill: "#E5A42B",
    "fill-rule": "evenodd"
  })
], -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", null, "đánh dấu đã đóng phí", -1)
const _hoisted_15 = [
  _hoisted_13,
  _hoisted_14
]
const _hoisted_16 = { class: "grid gap-4 mb-10 md-down:gap-4 grid-cols-3 md-down:grid-cols-1" }
const _hoisted_17 = { class: "bg-white p-4 rounded-xl border-sm shadow-sm flex items-center justify-between" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "flex items-center flex-nowrap" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    fill: "none",
    height: "20",
    viewBox: "0 0 20 20",
    width: "20",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M17.4729 3.29087L12.4819 17.2255C12.4224 17.3902 12.2661 17.4999 12.091 17.5H11.9579C11.7945 17.5 11.6457 17.4061 11.5752 17.2587L9.61212 13.0992C9.32305 12.4859 9.43494 11.7586 9.89494 11.2606L12.3904 8.53194C12.5436 8.37126 12.5436 8.1186 12.3904 7.95792L12.0743 7.64179C11.9137 7.48861 11.661 7.48861 11.5004 7.64179L8.77198 10.1375C8.27405 10.5976 7.54681 10.7095 6.93364 10.4204L2.77451 8.45707C2.61412 8.39667 2.50582 8.24569 2.50001 8.07439V7.94128C2.48528 7.7541 2.59775 7.58026 2.77451 7.517L16.7076 2.5255C16.8574 2.47049 17.0255 2.50605 17.1401 2.61701L17.3564 2.83331C17.4864 2.94689 17.5327 3.12896 17.4729 3.29087Z",
      fill: "#2AA797"
    })
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "text-neutral-500 text-sm ml-2" }, " Thông báo đã gửi ")
], -1)
const _hoisted_19 = { class: "flex items-center flex-nowrap justify-between" }
const _hoisted_20 = { class: "text-neutral-600 font-bold text-4xl" }
const _hoisted_21 = { class: "bg-white p-4 rounded-xl border-sm shadow-sm flex items-center justify-between" }
const _hoisted_22 = /*#__PURE__*/_createStaticVNode("<div class=\"flex items-center flex-nowrap\"><svg fill=\"none\" height=\"20\" viewBox=\"0 0 21 20\" width=\"21\" xmlns=\"http://www.w3.org/2000/svg\"><g clip-path=\"url(#clip0_1704:5253)\"><path clip-rule=\"evenodd\" d=\"M2.83073 0C1.91025 0 1.16406 0.746192 1.16406 1.66667V18.3333C1.16406 19.2538 1.91026 20 2.83073 20H10.921C9.53699 18.7784 8.66406 16.9231 8.66406 14.9319C8.66406 11.25 11.6488 8.33333 15.3307 8.33333C16.2148 8.33333 17.0587 8.50542 17.8307 8.81793V1.66667C17.8307 0.746192 17.0845 0 16.1641 0H2.83073ZM2.83073 7.08333C2.60061 7.08333 2.41406 7.26988 2.41406 7.5C2.41406 7.73012 2.60061 7.91667 2.83073 7.91667H10.7474C10.9775 7.91667 11.1641 7.73012 11.1641 7.5C11.1641 7.26988 10.9775 7.08333 10.7474 7.08333H2.83073ZM2.83073 9.58333C2.60061 9.58333 2.41406 9.76988 2.41406 10C2.41406 10.2301 2.60061 10.4167 2.83073 10.4167H9.08073C9.31085 10.4167 9.4974 10.2301 9.4974 10C9.4974 9.76988 9.31085 9.58333 9.08073 9.58333H2.83073ZM2.83073 12.0833C2.60061 12.0833 2.41406 12.2699 2.41406 12.5C2.41406 12.7301 2.60061 12.9167 2.83073 12.9167H7.41406C7.64418 12.9167 7.83073 12.7301 7.83073 12.5C7.83073 12.2699 7.64418 12.0833 7.41406 12.0833H2.83073ZM2.83073 14.5833C2.60061 14.5833 2.41406 14.7699 2.41406 15C2.41406 15.2301 2.60061 15.4167 2.83073 15.4167H5.7474C5.97751 15.4167 6.16406 15.2301 6.16406 15C6.16406 14.7699 5.97751 14.5833 5.7474 14.5833H2.83073ZM3.2474 2.91667C2.78716 2.91667 2.41406 3.28976 2.41406 3.75C2.41406 4.21024 2.78716 4.58333 3.2474 4.58333H14.4974C14.9576 4.58333 15.3307 4.21024 15.3307 3.75C15.3307 3.28976 14.9576 2.91667 14.4974 2.91667H3.2474Z\" fill=\"#94A3B8\" fill-rule=\"evenodd\"></path><path clip-rule=\"evenodd\" d=\"M20.3307 15C20.3307 17.7614 18.0922 20 15.3307 20C12.5693 20 10.3307 17.7614 10.3307 15C10.3307 12.2386 12.5693 10 15.3307 10C18.0922 10 20.3307 12.2386 20.3307 15ZM13.6767 12.904C13.5547 12.782 13.3568 12.782 13.2348 12.904C13.1127 13.0261 13.1127 13.2239 13.2348 13.346L14.8888 15L13.2348 16.654C13.1127 16.7761 13.1127 16.9739 13.2348 17.096C13.3568 17.218 13.5547 17.218 13.6767 17.096L15.3307 15.4419L16.9848 17.096C17.1068 17.218 17.3047 17.218 17.4267 17.096C17.5487 16.9739 17.5487 16.7761 17.4267 16.654L15.7727 15L17.4267 13.346C17.5487 13.2239 17.5487 13.0261 17.4267 12.904C17.3047 12.782 17.1068 12.782 16.9848 12.904L15.3307 14.5581L13.6767 12.904Z\" fill=\"#94A3B8\" fill-rule=\"evenodd\"></path></g><defs><clipPath id=\"clip0_1704:5253\"><rect fill=\"white\" height=\"20\" transform=\"translate(0.332031)\" width=\"20\"></rect></clipPath></defs></svg><div class=\"text-neutral-500 text-sm ml-2\"> Bản nháp </div></div>", 1)
const _hoisted_23 = { class: "flex items-center flex-nowrap justify-between" }
const _hoisted_24 = { class: "text-neutral-600 font-bold text-4xl" }
const _hoisted_25 = { class: "bg-white p-4 rounded-xl border-sm shadow-sm flex items-center justify-between" }
const _hoisted_26 = /*#__PURE__*/_createStaticVNode("<div class=\"flex items-center flex-nowrap\"><svg fill=\"none\" height=\"20\" viewBox=\"0 0 21 20\" width=\"21\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M14.1528 5H6.51421C6.51421 5 1.16663 9.73633 1.16663 15.2637C1.16663 18.4206 3.46625 20 4.9859 20H15.6807C17.2067 20 19.5 18.4204 19.5 15.2637C19.5 9.73633 14.1524 5 14.1524 5H14.1528ZM11.0965 15.9725V17.2366H9.57045L9.5703 15.9767C8.44557 15.7606 7.73906 15.0433 7.68892 14.0018H9.01225C9.07699 14.5484 9.61013 14.9007 10.3815 14.9007C11.0923 14.9007 11.5961 14.5442 11.5961 14.0365C11.5961 13.6043 11.27 13.3579 10.4673 13.1722L9.6164 12.9843C8.42474 12.7271 7.8394 12.0854 7.8394 11.0547C7.8394 10.0241 8.50422 9.28068 9.56201 9.03651V7.76366H11.088V9.03848C12.1208 9.27617 12.8086 10.0043 12.842 10.9831L11.5647 10.9832C11.5 10.4495 11.0191 10.0931 10.3585 10.0931C9.69793 10.0931 9.22122 10.4215 9.22122 10.9358C9.22122 11.3529 9.5327 11.5841 10.2999 11.7612L11.088 11.934C12.4029 12.2192 12.9694 12.7983 12.9694 13.855C12.9696 14.985 12.2672 15.7413 11.0965 15.9725L11.0965 15.9725Z\" fill=\"#2AA797\"></path><path d=\"M13.8073 0.830102H11.8869C11.4902 0.3017 10.9257 0 10.3334 0C9.74109 0 9.17661 0.301716 8.7799 0.830102H6.85953C6.62981 0.831217 6.41548 0.968534 6.28656 1.19681C6.15764 1.4251 6.13086 1.71518 6.21494 1.97198L6.85951 4.16667H13.8071L14.4516 1.97198C14.5357 1.71519 14.5089 1.42511 14.38 1.19681C14.2511 0.968521 14.0368 0.831219 13.8071 0.830102H13.8073Z\" fill=\"#2AA797\"></path></svg><div class=\"text-neutral-500 text-sm ml-2\"> Đã đóng học phí </div></div>", 1)
const _hoisted_27 = { class: "flex items-center flex-nowrap gap-2" }
const _hoisted_28 = { class: "text-neutral-600 font-bold text-4xl" }
const _hoisted_29 = { class: "shadow-sm sm:rounded-2xl overflow-hidden" }
const _hoisted_30 = { class: "__record__table overflow-x-auto scroll-bar" }
const _hoisted_31 = { class: "overflow-hidden sm:rounded-t-2xl w-fit min-w-full" }
const _hoisted_32 = { class: "min-w-full divide-y text-neutral-200" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("thead", { class: "bg-neutral-100 h-16" }, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      class: "px-3 py-3 text-center text-xs font-semibold text-neutral-600 uppercase tracking-wider w-16 whitespace-nowrap",
      scope: "col"
    }, " STT "),
    /*#__PURE__*/_createElementVNode("th", {
      class: "px-3 py-3 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider whitespace-nowrap",
      scope: "col"
    }, " tên học sinh "),
    /*#__PURE__*/_createElementVNode("th", {
      class: "px-3 py-3 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider whitespace-nowrap",
      scope: "col"
    }, " Trạng thái "),
    /*#__PURE__*/_createElementVNode("th", {
      class: "px-3 py-3 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider whitespace-nowrap",
      scope: "col"
    }, " Ngày tạo "),
    /*#__PURE__*/_createElementVNode("th", {
      class: "px-3 py-3 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider whitespace-nowrap",
      scope: "col"
    }, " Ngày Gửi "),
    /*#__PURE__*/_createElementVNode("th", {
      class: "px-3 py-3 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider whitespace-nowrap",
      scope: "col"
    }, " PH Đã xem "),
    /*#__PURE__*/_createElementVNode("th", {
      class: "px-3 py-3 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider whitespace-nowrap",
      scope: "col"
    }, " đã đóng học phí "),
    /*#__PURE__*/_createElementVNode("th", {
      class: "px-3 py-3 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider whitespace-nowrap",
      scope: "col"
    }, " GỬI LẠI ")
  ])
], -1)
const _hoisted_34 = ["onClick"]
const _hoisted_35 = { class: "px-3 py-4 text-center text-neutral-700" }
const _hoisted_36 = { class: "px-3 py-4 whitespace-nowrap text-neutral-700" }
const _hoisted_37 = { class: "flex items-center cursor-pointer" }
const _hoisted_38 = ["src"]
const _hoisted_39 = { class: "text-xs font-medium leading-none text-white" }
const _hoisted_40 = ["onClick"]
const _hoisted_41 = { class: "px-3 py-4 whitespace-nowrap text-neutral-700" }
const _hoisted_42 = { class: "ml-6" }
const _hoisted_43 = {
  key: 0,
  class: "flex items-center gap-2"
}
const _hoisted_44 = {
  key: 1,
  style: {"color":"#e37056"},
  class: "flex items-center gap-2 font-semibold"
}
const _hoisted_45 = {
  key: 2,
  class: "flex items-center gap-2 font-semibold text-green-500"
}
const _hoisted_46 = { class: "px-3 py-4 whitespace-nowrap text-neutral-700" }
const _hoisted_47 = { key: 0 }
const _hoisted_48 = { key: 1 }
const _hoisted_49 = { class: "px-3 py-4 whitespace-nowrap text-neutral-700" }
const _hoisted_50 = { key: 0 }
const _hoisted_51 = { key: 1 }
const _hoisted_52 = { class: "px-3 py-4 whitespace-nowrap text-neutral-700" }
const _hoisted_53 = { class: "px-3 py-4 whitespace-nowrap text-neutral-700" }
const _hoisted_54 = {
  key: 0,
  fill: "none",
  height: "20",
  viewBox: "0 0 20 20",
  width: "20",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_55 = /*#__PURE__*/_createElementVNode("path", {
  "clip-rule": "evenodd",
  d: "M11.212 6.21209C11.5782 5.84597 12.1717 5.84597 12.5379 6.21209C12.8995 6.57371 12.9039 7.15727 12.5512 7.52434L7.56092 13.7622C7.55371 13.7712 7.54602 13.7798 7.53787 13.7879C7.17175 14.154 6.57816 14.154 6.21204 13.7879L2.90398 10.4799C2.53787 10.1137 2.53787 9.52015 2.90398 9.15403C3.2701 8.78791 3.86369 8.78791 4.22981 9.15403L6.84671 11.7709L11.1872 6.24013C11.1949 6.23029 11.2032 6.22093 11.212 6.21209Z",
  fill: "#2AA797",
  "fill-rule": "evenodd"
}, null, -1)
const _hoisted_56 = /*#__PURE__*/_createElementVNode("path", {
  "clip-rule": "evenodd",
  d: "M10.0615 12.6374L11.212 13.7879C11.5782 14.154 12.1718 14.154 12.5379 13.7879C12.546 13.7798 12.5537 13.7712 12.5609 13.7622L17.5512 7.52434C17.9039 7.15727 17.8995 6.57371 17.5379 6.21209C17.1717 5.84597 16.5782 5.84597 16.212 6.21209C16.2032 6.22093 16.1949 6.23029 16.1872 6.24013L11.8467 11.7709L11.24 11.1642L10.0615 12.6374Z",
  fill: "#2AA797",
  "fill-rule": "evenodd"
}, null, -1)
const _hoisted_57 = [
  _hoisted_55,
  _hoisted_56
]
const _hoisted_58 = { class: "px-3 py-4 whitespace-nowrap text-neutral-700" }
const _hoisted_59 = {
  key: 1,
  class: "w-full h-full flex items-center justify-center flex-col"
}
const _hoisted_60 = /*#__PURE__*/_createElementVNode("img", {
  alt: "",
  height: "250",
  src: _imports_0,
  width: "250"
}, null, -1)
const _hoisted_61 = /*#__PURE__*/_createElementVNode("div", {
  class: "text-neutral-500 text-lg text-center",
  style: {"max-width":"700px"}
}, " Không có thông báo ", -1)
const _hoisted_62 = [
  _hoisted_60,
  _hoisted_61
]
const _hoisted_63 = {
  key: 1,
  class: "fixed top-1/2 left-1/2"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SlideOverFeeNotices = _resolveComponent("SlideOverFeeNotices")!
  const _component_CreateNotify = _resolveComponent("CreateNotify")!
  const _component_fee_poper = _resolveComponent("fee-poper")!
  const _component_DaInfinityLoading = _resolveComponent("DaInfinityLoading")!
  const _component_Loading = _resolveComponent("Loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: _normalizeClass(_ctx.sideOverShow ? 'side-over--active' : '')
    }, [
      (_ctx.sideOverShow)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "fixed h-screen w-screen top-0 left-0 bg-black opacity-20 z-30",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.sideOverShow = false))
          }))
        : _createCommentVNode("", true),
      (_ctx.type == 'filter')
        ? (_openBlock(), _createBlock(_component_SlideOverFeeNotices, {
            key: 1,
            onCancel: _cache[1] || (_cache[1] = ($event: any) => (_ctx.filterSubmit($event))),
            onClose: _ctx.closeSideOver,
            onSubmit: _cache[2] || (_cache[2] = ($event: any) => (_ctx.filterSubmit($event)))
          }, null, 8, ["onClose"]))
        : _createCommentVNode("", true),
      (_ctx.type == 'create')
        ? (_openBlock(), _createBlock(_component_CreateNotify, {
            key: 2,
            open: _ctx.sideOverShow,
            onClose: _ctx.closeSideOver
          }, null, 8, ["open", "onClose"]))
        : _createCommentVNode("", true)
    ], 2),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("button", {
            class: "h-12 button-p btn--ghost text-center mr-3 px-6 whitespace-nowrap",
            type: "button",
            onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.openSideOver('create')), ["stop"]))
          }, " Tạo thông báo mới "),
          _createElementVNode("div", {
            class: "w-30 bg-white p-3 rounded-md border shadow-sm border-neutral-200 cursor-pointer flex items-center",
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.openSideOver('filter')))
          }, _hoisted_7)
        ])
      ]),
      (!_ctx.isLoading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            (_ctx.notificationList && _ctx.notificationList.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.notificationList, (notice) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: notice.month_start,
                      class: "mb-10"
                    }, [
                      _createElementVNode("div", _hoisted_10, [
                        _createElementVNode("div", _hoisted_11, " Tháng " + _toDisplayString(notice.month_start
									? _ctx.$filters.toMMYYY(notice.month_start)
									: ''), 1),
                        _createElementVNode("div", {
                          class: "font-semibold text-yellow-600 flex items-center justify-end gap-2 uppercase text-sm cursor-pointer",
                          onClick: ($event: any) => (
								_ctx.$router.push(
									`/fee-notices/mark_paid?month_start=${notice.month_start}`
								)
							)
                        }, _hoisted_15, 8, _hoisted_12)
                      ]),
                      _createElementVNode("div", _hoisted_16, [
                        _createElementVNode("div", _hoisted_17, [
                          _hoisted_18,
                          _createElementVNode("div", _hoisted_19, [
                            _createElementVNode("div", _hoisted_20, _toDisplayString(notice.sent_count || 0), 1)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_21, [
                          _hoisted_22,
                          _createElementVNode("div", _hoisted_23, [
                            _createElementVNode("div", _hoisted_24, _toDisplayString(notice.draft_count || 0), 1)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_25, [
                          _hoisted_26,
                          _createElementVNode("div", _hoisted_27, [
                            _createElementVNode("div", _hoisted_28, _toDisplayString(notice.price_paid_percent || 0) + "% ", 1),
                            _createVNode(_component_fee_poper, { notice: notice }, null, 8, ["notice"])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_29, [
                        _createElementVNode("div", _hoisted_30, [
                          _createElementVNode("div", _hoisted_31, [
                            _createElementVNode("table", _hoisted_32, [
                              _hoisted_33,
                              _createElementVNode("tbody", null, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(notice.tuition_notices_by_month, (item, index) => {
                                  return (_openBlock(), _createElementBlock("tr", {
                                    key: item.id,
                                    class: _normalizeClass([
												index % 2 === 0
													? 'bg-white'
													: 'bg-neutral-50'
											, "text-neutral-700 cursor-pointer hover:bg-orange-50"]),
                                    onClick: _withModifiers(($event: any) => (
												_ctx.$router.push(
													`/fee-notices/${item?.notice?.id}`
												)
											), ["stop"])
                                  }, [
                                    _createElementVNode("td", null, [
                                      _createElementVNode("div", _hoisted_35, _toDisplayString(index + 1), 1)
                                    ]),
                                    _createElementVNode("td", _hoisted_36, [
                                      _createElementVNode("div", _hoisted_37, [
                                        (
															item?.student
																?.profile_photo
																?.w200
														)
                                          ? (_openBlock(), _createElementBlock("img", {
                                              key: 0,
                                              src: 
															item?.student
																?.profile_photo
																?.w200
														,
                                              alt: "",
                                              class: "shadow-sm inline-block h-6 w-6 rounded-full"
                                            }, null, 8, _hoisted_38))
                                          : (_openBlock(), _createElementBlock("span", {
                                              key: 1,
                                              style: _normalizeStyle({
															background:
																item?.student
																	?.profile_photo
																	?.default
																	?.color,
														}),
                                              class: "inline-flex items-center justify-center h-6 w-6 rounded-full"
                                            }, [
                                              _createElementVNode("span", _hoisted_39, _toDisplayString(item?.student
																	?.profile_photo
																	?.default
																	?.initial), 1)
                                            ], 4)),
                                        _createElementVNode("div", {
                                          class: "ml-4 font-semibold text-orange-600 hover:underline z-20",
                                          onClick: _withModifiers(($event: any) => (
															_ctx.$router.push(
																`/record/student/${item?.student?.id}`
															)
														), ["stop"])
                                        }, _toDisplayString(item?.student?.name), 9, _hoisted_40)
                                      ])
                                    ]),
                                    _createElementVNode("td", _hoisted_41, [
                                      _createElementVNode("div", _hoisted_42, [
                                        (
															item.notice
																.state ===
															'draft'
														)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_43, " Bản nháp "))
                                          : (
															item.notice
																.state ===
															'withdrawn'
														)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_44, " Đã thu hồi "))
                                            : (_openBlock(), _createElementBlock("div", _hoisted_45, " Đã gửi "))
                                      ])
                                    ]),
                                    _createElementVNode("td", _hoisted_46, [
                                      (
														item?.notice
															?.inserted_at
													)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_47, _toDisplayString(_ctx.$filters.formatDateDDMM(
															item?.notice
																?.inserted_at
														)), 1))
                                        : (_openBlock(), _createElementBlock("div", _hoisted_48, "-"))
                                    ]),
                                    _createElementVNode("td", _hoisted_49, [
                                      (item?.notice?.sent_at)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_50, _toDisplayString(_ctx.$filters.formatDateDDMM(
															item?.notice
																?.sent_at
														)), 1))
                                        : (_openBlock(), _createElementBlock("div", _hoisted_51, "-"))
                                    ]),
                                    _createElementVNode("td", _hoisted_52, [
                                      _createElementVNode("div", null, [
                                        _createElementVNode("span", null, _toDisplayString(item.notice
																.view_count ||
															'0') + " / " + _toDisplayString(item.notice
																.total_parent_received ||
															'0'), 1)
                                      ])
                                    ]),
                                    _createElementVNode("td", _hoisted_53, [
                                      (item.paid)
                                        ? (_openBlock(), _createElementBlock("svg", _hoisted_54, _hoisted_57))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _createElementVNode("td", _hoisted_58, _toDisplayString(item?.resent_count), 1)
                                  ], 10, _hoisted_34))
                                }), 128))
                              ])
                            ])
                          ])
                        ])
                      ])
                    ]))
                  }), 128)),
                  (_ctx.isInfinityLoading)
                    ? (_openBlock(), _createBlock(_component_DaInfinityLoading, {
                        key: 0,
                        loaded: _ctx.stopLoad,
                        onInfiniteLoad: _ctx.getNotificationList
                      }, null, 8, ["loaded", "onInfiniteLoad"]))
                    : _createCommentVNode("", true)
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_59, _hoisted_62))
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_63, [
            _createVNode(_component_Loading)
          ]))
    ])
  ], 64))
}